/* X-CONSENSO 19/10/2026. Il riquadro dei cookie del tema (snippets/bh-consenso.liquid), al posto dell'app dei cookie tolta il 19/10.
   Non scrive testi nella pagina: i testi li scrive Liquid. Qui si apre, si chiude e si salva la scelta.
   La scelta sta negli stessi cookie dell'app di prima, con gli stessi valori: cookieconsent_status (allow, dismiss, accept_selected, accept_all, reject_all)
   e cookieconsent_preferences_disabled (categorie bloccate separate da virgola), durata dalle impostazioni, path=/.
   A Shopify va con setTrackingConsent come faceva l'app di prima: a ogni pagina se c'è una scelta, e prima della scelta se almeno una categoria
   non è bloccata. Evento «bh:consenso» sulla window a ogni stato. API window.bhConsenso: apri() (preferenze, la usa il link «Preferenze cookie» del piede), avviso(), stato(). */
(function () {
  'use strict';
  var W = window, D = document;
  var dlg = D.getElementById('bh-consenso');
  if (!dlg || W.bhConsenso) return;
  var cfg = {};
  try { cfg = JSON.parse(D.getElementById('bh-consenso-dati').textContent) || {}; } catch (e) {}
  var CAT = ['analytics', 'marketing', 'functionality'];
  var K_STATO = 'cookieconsent_status', K_BLOC = 'cookieconsent_preferences_disabled';
  var avviso = dlg.querySelector('[data-bhc-avviso]'), pannello = dlg.querySelector('[data-bhc-pannello]');
  var interruttori = dlg.querySelectorAll('[data-bhc-cat]');
  var vista = null, daAvviso = false;

  function lista(s) {
    var out = [];
    String(s || '').split(',').forEach(function (x) { x = x.trim(); if (CAT.indexOf(x) >= 0 && out.indexOf(x) < 0) out.push(x); });
    return out;
  }
  function leggiCookie(n) {
    var p = D.cookie ? D.cookie.split(';') : [];
    for (var i = 0; i < p.length; i++) {
      var c = p[i].replace(/^\s+/, '');
      if (c.indexOf(n + '=') === 0) { try { return decodeURIComponent(c.slice(n.length + 1)); } catch (e) { return c.slice(n.length + 1); } }
    }
    return null;
  }
  function scriviCookie(n, v) {
    var g = Number(cfg.giorni) || 365, d = new Date();
    d.setTime(d.getTime() + g * 864e5);
    D.cookie = n + '=' + v + '; expires=' + d.toUTCString() + '; path=/';
  }
  function scelta() {
    var s = leggiCookie(K_STATO);
    return s ? { stato: s, bloccate: lista(leggiCookie(K_BLOC)) } : null;
  }
  function cancellaCookie(cat) {
    var nomi = String((cfg.cookie && cfg.cookie[cat]) || '').split(',');
    var h = location.hostname, base = h.split('.').slice(-2).join('.');
    var tutti = D.cookie || '';
    nomi.forEach(function (n) {
      n = n.trim();
      if (!n || tutti.indexOf(n + '=') < 0) return;
      var morto = n + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      D.cookie = morto;
      [h, '.' + h, '.' + base].forEach(function (dom) { D.cookie = morto + '; domain=' + dom; });
    });
  }
  function permessi(bloccate) {
    return { analytics: bloccate.indexOf('analytics') < 0, marketing: bloccate.indexOf('marketing') < 0, functionality: bloccate.indexOf('functionality') < 0 };
  }
  function statoSegnale(bloccate, iniziale) {
    if (iniziale) return 'allow';
    if (!bloccate.length) return 'accept_all';
    return bloccate.indexOf('marketing') >= 0 && bloccate.indexOf('analytics') >= 0 ? 'decline' : 'allow';
  }
  function aShopify(bloccate) {
    var p = permessi(bloccate);
    var dati = { analytics: p.analytics, marketing: p.marketing, preferences: p.functionality };
    if (cfg.vendita) dati.sale_of_data = p.marketing;
    function manda() {
      var cp = W.Shopify && W.Shopify.customerPrivacy;
      if (cp && typeof cp.setTrackingConsent === 'function') { try { cp.setTrackingConsent(dati, function () {}); } catch (e) {} }
    }
    if (W.Shopify && W.Shopify.customerPrivacy) return manda();
    if (W.Shopify && typeof W.Shopify.loadFeatures === 'function') {
      try { W.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) manda(); }); } catch (e) {}
    }
  }
  function annuncia(bloccate, iniziale, s) {
    var p = permessi(bloccate);
    var det = { scelta: !!s, stato: s ? s : null, iniziale: !!iniziale, analytics: p.analytics, marketing: p.marketing, functionality: p.functionality };
    try { W.dispatchEvent(new CustomEvent('bh:consenso', { detail: det })); } catch (e) {}
    if (cfg.datalayer) {
      try {
        W.dataLayer = W.dataLayer || [];
        W.dataLayer.push({ event: 'consent_status', timestamp: null, status: statoSegnale(bloccate, iniziale && !s), consentmoStatus: 'default', /* stessa forma di prima, per chi la legge in dataLayer */
          categories: [{ necessary: true, analytics: p.analytics, marketing: p.marketing, functionality: p.functionality }] });
      } catch (e) {}
    }
  }
  function applica(bloccate, iniziale, s) {
    if (cfg.cancella) bloccate.forEach(cancellaCookie);
    if (s || bloccate.length < CAT.length) aShopify(bloccate);
    annuncia(bloccate, iniziale, s);
  }

  function spunte(bloccate) {
    for (var i = 0; i < interruttori.length; i++) {
      var on = bloccate.indexOf(interruttori[i].getAttribute('data-bhc-cat')) < 0;
      interruttori[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }
  function mostra(v) {
    vista = v;
    avviso.hidden = v !== 'avviso';
    pannello.hidden = v !== 'pannello';
    dlg.setAttribute('data-bhc-vista', v);
    dlg.setAttribute('aria-labelledby', v === 'avviso' ? 'bhc-testo' : 'bhc-titolo');
    if (!dlg.open) {
      if (typeof dlg.showModal === 'function') { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
      else { dlg.setAttribute('open', ''); dlg.classList.add('bhc--senza-modale'); }
    }
    var f = D.getElementById(v === 'avviso' ? 'bhc-testo' : 'bhc-titolo');
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
  }
  function chiudi() {
    vista = null;
    if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
  }
  function salva(stato, bloccate) {
    scriviCookie(K_STATO, stato);
    scriviCookie(K_BLOC, bloccate.join(','));
    chiudi();
    applica(bloccate, false, stato);
  }
  function apriPreferenze(dall) {
    var s = scelta();
    spunte(s ? s.bloccate : lista(cfg.spunte));
    daAvviso = !!dall || !s;
    mostra('pannello');
  }
  function chiudiPannello() {
    if (daAvviso && !scelta()) { daAvviso = false; mostra('avviso'); } else chiudi();
  }
  function selezionate() {
    var b = [];
    for (var i = 0; i < interruttori.length; i++) if (interruttori[i].getAttribute('aria-checked') !== 'true') b.push(interruttori[i].getAttribute('data-bhc-cat'));
    return b;
  }

  dlg.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-bhc-x]')) return salva('dismiss', lista(cfg.x));
    if (t.closest('[data-bhc-accetta]')) return salva('allow', []);
    if (t.closest('[data-bhc-preferenze]')) return apriPreferenze(true);
    if (t.closest('[data-bhc-pannello-x]')) return chiudiPannello();
    if (t.closest('[data-bhc-selezionato]')) return salva('accept_selected', selezionate());
    if (t.closest('[data-bhc-rifiuta]')) return salva('reject_all', CAT.slice());
    if (t.closest('[data-bhc-tutti]')) return salva('accept_all', []);
    var b = t.closest('[data-bhc-cat]');
    if (b) b.setAttribute('aria-checked', b.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
  });
  /* Esc: sull'avviso vale come la X (come l'app di prima), sulle preferenze torna all'avviso o chiude */
  dlg.addEventListener('cancel', function (e) {
    e.preventDefault();
    if (vista === 'avviso') salva('dismiss', lista(cfg.x)); else if (vista === 'pannello') chiudiPannello();
  });
  /* se il browser chiude la finestra da sé (Esc ripetuto) e non c'è ancora una scelta, l'avviso torna */
  dlg.addEventListener('close', function () {
    var v = vista; vista = null;
    if (v && !scelta()) setTimeout(function () { mostra('avviso'); }, 0);
  });
  /* col riquadro aperto le scorciatoie del ⌘K (Ctrl o Cmd+K, «/») non aprono niente sotto di lui: si fermano qui, prima del tema */
  W.addEventListener('keydown', function (e) {
    if (!dlg.open) return;
    if (((e.metaKey || e.ctrlKey) && !e.altKey && (e.key === 'k' || e.key === 'K')) || (e.key === '/' && !e.metaKey && !e.ctrlKey)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  W.bhConsenso = {
    apri: function () { apriPreferenze(false); },
    avviso: function () { mostra('avviso'); },
    chiudi: chiudi,
    aperto: function () { return !!dlg.open; },
    stato: function () { var s = scelta(), b = s ? s.bloccate : lista(cfg.prima), p = permessi(b); return { scelta: s ? s.stato : null, analytics: p.analytics, marketing: p.marketing, functionality: p.functionality }; }
  };

  var s = scelta();
  if (s) applica(s.bloccate, true, s.stato);
  else { applica(lista(cfg.prima), true, null); mostra('avviso'); }
})();
